import { httpClient } from '../http/httpClient.js';
import { buildQueryString, ensureSuccessPayload, getCollection } from './serviceUtils.js';

const CATEGORIES_API_URL = '/api/categories';

const buildCategoriesUrl = (params = {}) => {
  const queryString = buildQueryString(params);
  return queryString ? `${CATEGORIES_API_URL}?${queryString}` : CATEGORIES_API_URL;
};

export const categoryService = {
  getCategories: async (params = {}) => {
    const payload = ensureSuccessPayload(
      await httpClient.get(buildCategoriesUrl(params)),
      'No se pudieron cargar las categorías.'
    );

    return {
      categories: getCollection(payload, ['responses']),
      pagination: payload?.pagination || null,
      payload
    };
  },

  createCategory: async (categoryData) => {
    const payload = await httpClient.post(CATEGORIES_API_URL, { data: categoryData });
    return ensureSuccessPayload(payload, 'No se pudo crear la categoría.');
  },

  updateCategory: async (categoryName, categoryData) => {
    const payload = await httpClient.put(`${CATEGORIES_API_URL}/${encodeURIComponent(categoryName)}`, {
      data: categoryData
    });
    return ensureSuccessPayload(payload, 'No se pudo actualizar la categoría.');
  },

  deactivateCategory: async (categoryName) => {
    const payload = await httpClient.delete(`${CATEGORIES_API_URL}/${encodeURIComponent(categoryName)}`);
    return ensureSuccessPayload(payload, 'No se pudo desactivar la categoría.');
  },

  restoreCategory: async (categoryName) => {
    return categoryService.updateCategory(categoryName, { isActive: true });
  }
};
